import { REDIRECTED_FROM_PARAM } from '@lib/auth/constants/redirected-from-param';

import { sanitizeRedirectUrl } from './sanitize-redirect-url';

/**
 * Appends a post-auth destination to an auth route so the
 * /login → /forgot-password → /login round trip keeps it.
 * No destination leaves the route bare; an unsafe one
 * collapses to the sanitizer's fallback.
 */
export function withRedirectedFrom(
  route: string,
  redirectedFrom: string | null | undefined
): string {
  if (!redirectedFrom) return route;

  const destination = sanitizeRedirectUrl(redirectedFrom);
  return `${route}?${REDIRECTED_FROM_PARAM}=${encodeURIComponent(destination)}`;
}
